var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getToken, handleTokenExpiration, isTokenInvalid } from './token';
const PING_INTERVAL_TIME = 60000;
const ping = ({ onRedirect }) => __awaiter(void 0, void 0, void 0, function* () {
    const token = getToken();
    const { env } = window;
    const response = yield fetch(`${env.API_GATEWAY_URL}/ping`, {
        headers: {
            Authorization: `Bearer ${token}`,
            ['x-region']: env.REGION,
        },
    });
    if (response.status === 302) {
        onRedirect === null || onRedirect === void 0 ? void 0 : onRedirect();
    }
    if (isTokenInvalid(response)) {
        handleTokenExpiration();
    }
});
/**
 * This function periodically makes requests to the backend. It is used to check expired tokens so that user
 * could be redirected to login page after token invalidation.
 */
export const startPinger = (pingProps = {}) => __awaiter(void 0, void 0, void 0, function* () {
    yield ping(pingProps);
    setInterval(() => {
        void ping(pingProps);
    }, PING_INTERVAL_TIME);
});
